"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _root = _interopRequireDefault(require("./root"));

var value = function value(factor) {
  return factor * _root["default"].baseSpace;
};

var s = function s(factor) {
  return "".concat(value(factor), "px");
};

var spacing = {
  s0: s(0),
  s1: s(1),
  s2: s(2),
  s3: s(3),
  s4: s(4),
  s5: s(5),
  s6: s(6),
  s7: s(7),
  s8: s(8),
  s9: s(9),
  s10: s(10),
  s11: s(11),
  s12: s(12),
  s: s,
  value: value
};
var _default = spacing;
exports["default"] = _default;